import { render, staticRenderFns } from "./WorkflowTabBar.vue?vue&type=template&id=6e983711"
import script from "./WorkflowTabBar.vue?vue&type=script&lang=js"
export * from "./WorkflowTabBar.vue?vue&type=script&lang=js"
import style0 from "./mqSharedStyles.css?vue&type=style&index=0&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e983711')) {
      api.createRecord('6e983711', component.options)
    } else {
      api.reload('6e983711', component.options)
    }
    module.hot.accept("./WorkflowTabBar.vue?vue&type=template&id=6e983711", function () {
      api.rerender('6e983711', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealMultiQueryWorkflow/WorkflowTabBar.vue"
export default component.exports